// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mxSA","option":"styles_option__3FdaO","active":"styles_active__3JqPO"};